import { Property as Domain, PropertyField } from 'modules/cm/RepaymentStrategy/RepaymentStrategy';
import { format } from 'utils/date';
import { Property as API } from '../Property';

const apiBuilder = (domain: Partial<Domain>) => {
  const api: Partial<API> = {};

  return {
    add(fields: PropertyField[]): void {
      const map = new Map([
        [
          PropertyField.FlatNumber,
          () => {
            api.flatNumber = domain[PropertyField.FlatNumber];
          },
        ],
        [
          PropertyField.BuildingNumber,
          () => {
            api.buildingNumber = domain[PropertyField.BuildingNumber];
          },
        ],
        [
          PropertyField.BuildingName,
          () => {
            api.buildingName = domain[PropertyField.BuildingName];
          },
        ],
        [
          PropertyField.Street,
          () => {
            api.street = domain[PropertyField.Street];
          },
        ],
        [
          PropertyField.City,
          () => {
            api.city = domain[PropertyField.City];
          },
        ],
        [
          PropertyField.County,
          () => {
            api.county = domain[PropertyField.County];
          },
        ],
        [
          PropertyField.PostCode,
          () => {
            api.postcode = domain[PropertyField.PostCode];
          },
        ],
        [
          PropertyField.CurrentMortgageBalance,
          () => {
            api.currentMortgageBalance = domain[PropertyField.CurrentMortgageBalance];
          },
        ],
        [
          PropertyField.DateOfPurchase,
          () => {
            const date = domain[PropertyField.DateOfPurchase];
            api.dateOfPurchase = date ? format(date).fromViewToRequest() : null;
          },
        ],
        [
          PropertyField.PurchasePrice,
          () => {
            api.purchasePrice = Number(domain[PropertyField.PurchasePrice]);
          },
        ],
        [
          PropertyField.CurrentMortgageBalance,
          () => {
            api.currentMortgageBalance = Number(domain[PropertyField.CurrentMortgageBalance]);
          },
        ],
      ]);

      fields.forEach((field) => {
        const adder = map.get(field);
        if (typeof adder === 'function') {
          adder();
        }
      });
    },
    getAPI() {
      return api;
    },
  };
};

export const mapPartialDomainToPartialApi = (domain: Partial<Domain>): Partial<API> => {
  const builder = apiBuilder(domain);
  builder.add(Object.keys(domain) as PropertyField[]);

  return builder.getAPI();
};

const mapDomainToAPI = (domain: Domain): API => {
  const builder = apiBuilder(domain);
  builder.add(Object.keys(domain) as PropertyField[]);

  return builder.getAPI() as API;
};

export const mapPropertyToApi = (domain: any): API => ({
  id: domain[PropertyField.Id],
  postcode: domain[PropertyField.PostCode],
  flatNumber: domain[PropertyField.FlatNumber],
  buildingNumber: domain[PropertyField.BuildingNumber],
  buildingName: domain[PropertyField.BuildingName],
  street: domain[PropertyField.Street],
  city: domain[PropertyField.City],
  county: domain[PropertyField.County],
  dateOfPurchase: domain[PropertyField.DateOfPurchase],
  purchasePrice: domain[PropertyField.PurchasePrice],
  currentMortgageBalance: domain[PropertyField.CurrentMortgageBalance],
});

export default mapDomainToAPI;
